import axios from 'axios'
import { useEffect, useState } from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import logo from '../media/Balanz_white_logo.svg'

export const VerifyInfo = () => {
    const history = useNavigate()
    const location = useLocation();

    useEffect(() => {
        if (location.state === undefined) {
            history('/')
        }
    }, []);

    const send = () => {
        history('/');
    }
    return (
        <div className='columns w-row container-log-check'>
            <div className='logocolumn w-col w-col-4 w-col-stack'>
                <img
                    src={logo}
                    loading='lazy'
                    alt='Balanz logo'
                    width='600'
                    sizes='(max-width: 479px) 63vw, (max-width: 767px) 43vw, (max-width: 991px) 36vw, 23vw'
                    className='loginlogo'
                />
            </div>
            <div className='formcolumn w-col w-col-8 w-col-stack'>
                <div className='form-info'>
                    <h4 className='h2-titles' style={{ textAlign: "center" }}>Welcome to Balanz</h4>
                    <p className='paragraph'>
                        You have sucesfully completed your request for access to the Balanz research website. Our team is reviewing your request and you should promptly receive a confirmation message, including a link to validate your credentials. Please contact your Balanz representative if you do not hear from us shortly.
                    </p>
                    <input
                        type='submit'
                        data-wait=''
                        value='Continue'
                        className='button continue w-button'
                        onClick={send}
                    />
                </div>
            </div>
        </div>
    )
}
